import Vue from 'vue';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

const bugsnagClient = bugsnag({
  apiKey: process.env.VUE_APP_BUGSNAG_API_KEY,
  releaseStage: process.env.VUE_APP_APP_MODE,
  notifyReleaseStages: ['staging', 'production'],
}).use(bugsnagVue, Vue);

export default bugsnagClient;
